/* Games index interactivity (loaded with defer by templates/page.games-index.liquid).
   Cards are server-rendered newest-first; this only handles multi-category filter
   (comma-split) + title/genre search on interaction. No reorder on load = no CLS. */
(function () {
  function setup() {
    var grid = document.getElementById('gx-grid');
    if (!grid) return false;
    var cards = [].slice.call(grid.querySelectorAll('.gx-card'));
    if (!cards.length) return false;
    if (grid.getAttribute('data-gx-init') === '1') return true;
    grid.setAttribute('data-gx-init', '1');

    // Cards are server-rendered newest-first — no reorder on load (no CLS). JS only filters/searches.
    var search = document.getElementById('gx-search');
    var clear = document.getElementById('gx-clear');
    var pills = document.getElementById('gx-pills');
    var empty = document.getElementById('gx-empty');
    var empty1 = document.getElementById('gx-empty-1');
    var empty2 = document.getElementById('gx-empty-2');
    var count = document.getElementById('gx-count');
    var cat = '', catLabel = '', q = '', qRaw = '';
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (cat) { var cs = (c.getAttribute('data-cat') || '').split(','); if (cs.indexOf(cat) === -1) ok = false; }
        if (q) { var n = c.getAttribute('data-name') || '', g = c.getAttribute('data-genre') || ''; if (n.indexOf(q) === -1 && g.indexOf(q) === -1) ok = false; }
        c.style.display = ok ? '' : 'none'; if (ok) shown++;
      });
      // Filtered-count line — only when a filter or search is active (mirrors the original).
      if (count) {
        if (cat || qRaw) {
          count.textContent = shown + (shown === 1 ? ' game' : ' games')
            + (cat ? ' in ' + catLabel : '')
            + (qRaw ? ' matching "' + qRaw + '"' : '');
          count.hidden = false;
        } else { count.hidden = true; }
      }
      // Empty state — message depends on whether the miss is a search or a category.
      if (empty) {
        if (shown === 0) {
          if (qRaw) {
            if (empty1) empty1.textContent = 'No games found matching your search';
            if (empty2) empty2.textContent = 'Try a different search term or browse all games';
          } else {
            if (empty1) empty1.textContent = 'No games in this category yet';
            if (empty2) empty2.textContent = 'More games will be added soon';
          }
          empty.hidden = false;
        } else { empty.hidden = true; }
      }
    }
    if (clear) clear.hidden = true;
    if (search) search.addEventListener('input', function () {
      qRaw = this.value.trim(); q = qRaw.toLowerCase();
      if (clear) clear.hidden = !this.value;
      apply();
    });
    if (clear) clear.addEventListener('click', function () {
      if (search) { search.value = ''; search.focus(); }
      qRaw = ''; q = ''; clear.hidden = true; apply();
    });
    if (pills) pills.addEventListener('click', function (e) {
      var b = e.target.closest('.gx__pill'); if (!b) return;
      cat = b.getAttribute('data-cat');
      catLabel = (b.textContent || '').trim();
      [].forEach.call(pills.querySelectorAll('.gx__pill'), function (p) { p.classList.toggle('is-active', p === b); });
      apply();
    });
    return true;
  }
  // setup() is idempotent (data-gx-init guard); the grid is server-rendered so the
  // first call succeeds — hook the native readiness triad, no polling needed.
  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
})();
